<template>
  <div class="print-container-component">
    <div>
      <div class="print-header" :style="header_style">
        <slot name="header" />
      </div>
      <div class="print-body">
        <slot />
      </div>
      <div class="print-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    header_style: {
      type: Object,
      default: {backgroundColor: 'white', color: 'black'},
    },
  },
  setup (props) {
    if (props.title) {
      document.title = props.title;
    }
    return {};
  }
}
</script>

<style lang="scss" scoped>
.print-container-component {
  //max-width: 21cm;
    max-width: 31cm;
  margin-left: auto;
  margin-right: auto;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  background-color: white;
  position: relative;
  .print-header,
  .print-footer {
    position: fixed;
    width: 100%;
    //max-width: 21cm;
    max-width: 31cm;
    margin: 0 auto;
    text-align: center;
    font-size: 12px;
    padding: 10px;
  }
  @media screen { 
    padding-top: 2em;
    margin-bottom: 15px;
    .print-header,
    .print-footer {
      position: absolute;
    }
  }
  .print-header {
    top: 0;
    left:0;
    right: 0;
  }
  .print-footer {
    bottom: 0;
  }
  .print-body {
    // padding-top: 25px;
    padding-bottom: 25px;
    font-size: 18px;
    > :deep(.large-text) {
        font-size: 24px;
    }
  }
}
</style>
<style lang="scss">
.print-container-component {
  .extra-product-line {
    background-color: #fff2cc;
    margin: -4px;
    padding: 4px;
  }
  .single-line, .extra-product-line {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    display: inline-block;
    text-overflow: ellipsis;
  }
  .single-line-block{
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
  }
  @media print {
    .print-link {
      color: inherit;
      text-decoration: none;
    }
  }
  @media screen {
    .print-link {
      text-decoration: underline;
    }
  }
}

@media print {
  .hide-print {
    display: none !important;
  }
  .content-body {
    width: 100% !important;
    max-width: unset !important;
    flex: unset !important;
  }
  body {
    background-color: white !important;
    margin: 0;
  }
}

@page {
  size: A4;
  @top-right {
    content: 'Side ' counter(page) ' af ' counter(pages);
  }
}

.print-avoid-break-inside {
  page-break-inside: avoid;
}

.print-break-after {
  page-break-after: always;
}
</style>